import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  const lastUpdated = "October 24, 2023";

  return (
    <div className="py-20 bg-slate-50 min-h-screen">
      <div className="container px-4 mx-auto max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white p-8 md:p-12 rounded-3xl shadow-soft border border-slate-100"
        >
          <h1 className="text-4xl font-bold text-primary mb-2">Privacy Policy</h1>
          <p className="text-slate-500 mb-8 border-b pb-8">Last Updated: {lastUpdated}</p>

          <div className="prose prose-slate max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">1. Introduction</h2>
              <p className="text-slate-600 leading-relaxed">
                Review Guru ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our reputation management services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">2. Information We Collect</h2>
              <div className="space-y-4">
                <h3 className="text-lg font-semibold text-slate-800">2.1 Personal Data</h3>
                <p className="text-slate-600">
                  We collect personally identifiable information that you voluntarily provide to us when you register for a free trial or contact us, including:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2">
                  <li>Name and contact information (email, phone number)</li>
                  <li>Business details (name, website, location count)</li>
                  <li>Payment information (processed securely through third-party providers)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">3. How We Use Your Information</h2>
              <p className="text-slate-600 mb-4">We use the information we collect to:</p>
              <ul className="list-disc pl-6 text-slate-600 space-y-2">
                <li>Provide, operate, and maintain our services</li>
                <li>Improve and personalize your experience</li>
                <li>Process transactions and send related information</li>
                <li>Send review requests to your customers on your behalf</li>
                <li>Communicate with you regarding updates and support</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">4. Data Security</h2>
              <p className="text-slate-600 leading-relaxed">
                We implement a variety of security measures to maintain the safety of your personal information. However, no method of transmission over the Internet or method of electronic storage is 100% secure. We strive to use commercially acceptable means to protect your personal data but cannot guarantee its absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4">5. Third-Party Services</h2>
              <p className="text-slate-600 leading-relaxed">
                Our service integrates with Google, Facebook, and other review platforms. By using Review Guru, you acknowledge that your interactions with these platforms are governed by their respective privacy policies.
              </p>
            </section>

            <section className="bg-primary/5 p-6 rounded-2xl border border-primary/10">
              <h2 className="text-2xl font-bold text-primary mb-4">6. Contact Us</h2>
              <p className="text-slate-600">
                If you have any questions about this Privacy Policy, please contact us at:
              </p>
              <div className="mt-4 font-medium text-primary">
                Email: support@reviewguru.au<br />
                Address: PO Box 260, Hallam Victoria 3803
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;